const main = async (glue) => {
    try {
        const context = await glue.windows.my()?.getContext();
        console.debug(`Sending FSBL.enterBootStage "${context?.stage}" to finsemble service`);
        await glue.interop.invoke("FSBL.enterBootStage", { stage: context?.stage });
        await glue.interop.invoke("T42.GD.Execute", { command: "signal-app-ready" });
        console.debug("Successfully delivered message. Closing.");
        glue.windows.my()?.close();
    }
    catch (e) {
        console.error("Error sending FSBL.enterBootStage to finsemble service", e);
    }
};
if (globalThis.glue42gd) {
    const glueFactory = globalThis.Glue;
    glueFactory?.({ appManager: "full", layouts: "full" }).then((glue) => {
        main(glue);
        globalThis.glue = glue;
    });
}
export {};
